const moderationFor = attachment =>
  attachment?.imageModeration || attachment?.image_moderation || {};

export const isAttachmentBlocked = attachment => {
  const moderation = moderationFor(attachment);

  return (
    moderation.status === 'pending' ||
    (moderation.blocked === true && moderation.approved !== true)
  );
};
